<template>
  <div>
    <div class="tabs">
      <div class="tab-item" :class="index === 0 ? 'active' : ''" @click="tapFn(0)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon6.png" alt="">
        SPBCN×个人赛
      </div>
      <div class="tab-item" :class="index === 1 ? 'active' : ''" @click="tapFn(1)">
        <img class="logo" src="https://cdn.spbcn.org/spbcnWeb/pic/new_homepage_imgicon7.png" alt="">
        ITSO×团体赛
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyComponent',
  props: {
    index: {
      type: Number
    }
  },
  methods: {
    tapFn (index) {
      console.log(index)
      this.$emit('tap', index)
    },
    handleAdd () {
      this.$emit('add')
    }
  }
}
</script>

<style lang="less" scoped>
.tabs{
  display: flex;
  align-items: flex-end;
  .tab-item{
    // width: 200px;
    padding-left: 20px;
    padding-right: 20px;
    height: 36px;
    border-radius: 14px 14px 0 0;
    color: #000;
    background-color: #fff;
    font-size: 14px;
    margin-right: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo{
    width: 28px;
    height: 28px;
    margin-right: 4px;
    object-fit: contain;
    display: none;
  }
  .active{
    // width: 260px;
    padding-left: 30px;
    padding-right: 30px;
    background-color: #FAD54A;
    height: 44px;
    font-weight: bold;
    font-size: 16px;
    .logo{
      display: block;
    }
  }
  .tab-add-btn{
    width: 120px;
    height: 36px;
    background-color: #fcedb6;
    color: #000;
    border-radius: 14px 14px 0 0;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover{
      background-color: #fbe491;
    }
  }
}
</style>
